import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ccButton from '@/components/cc-button.vue'
Vue.component('cc-button', ccButton)
import ccLoading from '@/components/cc-loading.vue'
Vue.component('cc-loading', ccLoading)
import ccToast from '@/components/cc-toast.vue'
Vue.component('cc-toast', ccToast)
import ccModal from '@/components/cc-modal.vue'
Vue.component('cc-modal', ccModal)

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
    data: {
        // startCountdown: 15, // 开始页面按钮倒计时,
        isConfirm: false, // 是否同意使用
        tips: '', // 使用提示
        tips2: '', // 裁剪提示
        shiliImg: '', // 拍照或上传示例图
        contact: '', // 联系专家
        global: {},
    }
}).$mount('#app')
